import { motion } from "framer-motion";
import { fadeUp, stagger } from "../lib/motion";
import { CHAPTERS, MISSION } from "../lib/site";

export const Manifesto = () => {
  return (
  <section className="relative py-28 lg:py-40 grid-bg" data-testid="manifesto-section">
    <div className="mx-auto max-w-[1400px] px-6 lg:px-10">
      <motion.div
        initial="hidden"
        whileInView="show"
        viewport={{ once: true, margin: "-100px" }}
        variants={stagger}
      >
        <motion.p variants={fadeUp} className="text-xs font-bold uppercase tracking-[0.3em] text-[#C6FF00] mb-6">
          / Brand Essence
        </motion.p>
        <motion.h2
          variants={fadeUp}
          className="text-5xl sm:text-6xl lg:text-8xl font-black uppercase tracking-tighter leading-[0.9] max-w-4xl"
        >
          Strategy. Systems. <span className="text-[#C6FF00]">Results.</span>
        </motion.h2>
      </motion.div>

      {/* Mission */}
      <motion.div
        initial="hidden"
        whileInView="show"
        viewport={{ once: true, margin: "-120px" }}
        variants={stagger}
        className="mt-16 lg:mt-20 grid grid-cols-1 lg:grid-cols-12 gap-6 lg:gap-10 items-start border-t border-[#2A2D34] pt-10"
        data-testid="mission-block"
      >
        <motion.p variants={fadeUp} className="lg:col-span-3 text-xs font-bold uppercase tracking-[0.3em] text-[#C6FF00] pt-3">
          / Our Mission
        </motion.p>
        <div className="lg:col-span-9 overflow-hidden">
          <motion.p
            variants={{
              hidden: { y: "110%" },
              show: { y: "0%", transition: { duration: 1, ease: [0.16, 1, 0.3, 1] } },
            }}
            className="text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight leading-[1.15] text-white"
            data-testid="mission-statement"
          >
            {MISSION}
          </motion.p>
        </div>
      </motion.div>

      <div className="mt-20 lg:mt-28 space-y-16 lg:space-y-24">
        {CHAPTERS.map((c, idx) => (
          <motion.div
            key={c.no}
            initial={{ opacity: 0, y: 60 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-120px" }}
            transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
            className="grid grid-cols-1 lg:grid-cols-12 gap-6 lg:gap-10 items-start border-t border-[#2A2D34] pt-10"
            data-testid={`manifesto-chapter-${c.no}`}
          >
            <div className="lg:col-span-3">
              <span className="text-7xl lg:text-8xl font-black leading-none text-[#C6FF00] lime-text-glow">
                {c.no}
              </span>
            </div>
            <div className="lg:col-span-4">
              <h3 className="text-4xl lg:text-5xl font-black uppercase tracking-tight">
                {c.title}
              </h3>
            </div>
            <div className="lg:col-span-5">
              <p className="text-lg text-[#8A939B] leading-relaxed font-medium">
                {c.body}
              </p>
            </div>
          </motion.div>
        ))}
      </div>

    </div>
  </section>
  );
};
